// src/components/Facilities.js
import React from 'react';

const Facilities = () => {
  return (
    <div className="facilities-container">
      <h2>Campus Facilities</h2>
      <p>
        Sumatidevi Tompe Institute provides a wide range of facilities to ensure a comfortable and productive environment for all its students and staff.
      </p>
      <h3>Key Facilities:</h3>
      <ul>
        <li>Modern Hostels (Separate for Boys and Girls)</li>
        <li>Well-maintained Canteen & Cafeteria</li>
        <li>Medical and First-Aid Services</li>
        <li>Transportation Services</li>
        <li>24/7 Security</li>
        <li>Counseling and Mentoring Services</li>
        <li>ATM Facility (if applicable)</li>
        <li>Wi-Fi Enabled Campus</li>
      </ul>
      {/* Add images or virtual tours of facilities */}
    </div>
  );
};

export default Facilities;